export interface CreateCompanyInputApiModel {
    domain: string;
    name: string;
    email: string;
}